var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThinX = function SvgThinX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "-1 -1 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1B",
    d: "M14.692 2.795a1.051 1.051 0 1 0-1.487-1.487L8 6.513 2.795 1.308a1.052 1.052 0 0 0-1.487 1.487L6.513 8l-5.205 5.205a1.052 1.052 0 1 0 1.487 1.487L8 9.487l5.205 5.205a1.051 1.051 0 1 0 1.487-1.487L9.487 8z"
  })));
};
export default SvgThinX;